import { render, staticRenderFns } from "./ResourcesPage.vue?vue&type=template&id=44b9d2d2&"
import script from "./ResourcesPage.vue?vue&type=script&lang=js&"
export * from "./ResourcesPage.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesPage.vue?vue&type=style&index=0&id=44b9d2d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports